import React from 'react';
import { motion } from 'framer-motion';

const partners = [
  'Indian Tea Board',
  'APEDA',
  'EU Customs',
  'Spices Board',
  'WCO Data Model',
  'Coffee Board',
  'IFOAM Organics',
  'EUR-Lex',
  'India Customs',
  'EU Regulation 2018/848',
];

export default function TrustedMarquee() {
  // Duplicate the list so the keyframe loop is seamless.
  const list = [...partners, ...partners];
  return (
    <section className="border-y border-white/5 py-10 overflow-hidden bg-navy-900/30">
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="text-center text-[10px] uppercase tracking-[0.3em] text-slate-500 font-mono mb-6"
      >
        Aligned with regulatory frameworks &amp; trade authorities
      </motion.div>
      <div className="relative">
        <div className="flex animate-marquee whitespace-nowrap gap-16">
          {list.map((p, i) => (
            <span
              key={`${p}-${i}`}
              className="font-display text-2xl md:text-3xl font-semibold text-slate-500/60 tracking-tight shrink-0"
              data-testid={`marquee-${i}`}
            >
              {p}
            </span>
          ))}
        </div>
        {/* Edge fade masks */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#0F172A]/80 to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#0F172A]/80 to-transparent" />
      </div>
    </section>
  );
}
